import React from 'react';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import SendIcon from '@material-ui/icons/Send';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption';
import MessageThreadMessagesEntry from './MessageThreadMessagesEntry';
import ConfirmDialog from '../parts/ConfirmDialog';
import confirm from '../shared/ConfirmDialog';
import { setData, setDataBatch } from '../../actions/index';

const styles = () => ({
  root: {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  noneSelected: {
    color: '#aaaaaa',
    fontStyle: 'italic',
    padding: '120px 60px',
    textAlign: 'center',
  },
  centerPadding: {
    padding: '120px 60px',
    textAlign: 'center',
  },
  centerPaddingSmall: {
    padding: '60px',
    textAlign: 'center',
  },
  topBanner: {
    padding: '10px 20px',
    fontSize: 18,
    color: '#fff',
    backgroundColor: '#39843b',
  },
  topBannerText: {
    display: 'inline-block',
    marginTop: 12,
    marginBottom: 12,
  },
  topBannerChip: {
    margin: '5px 5px',
    color: '#ffffff',
    backgroundColor: '#388e3c',
  },
  topBannerChipShowMore: {
    cursor: 'pointer',
    fontWeight: 'bold',
    '&:focus, &:hover': {
      backgroundColor: '#388e3c',
    },
  },
  backButtonIcon: {
    color: '#fff',
  },
  lockUnlockIconButton: {
    float: 'right',
  },
  lockUnlockIcon: {
    color: '#fff',
  },
  messagesContainerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  messagesWrapper: {
    position: 'relative',
    flex: '1 1 auto',
  },
  messagesInner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    position: 'absolute',
    top: 0,
  },
  messagesInnerDownPusher: {
    flex: '1 1 auto',
  },
  messagesInnerContainer: {
    flex: '0 0 auto',
  },
  messagesTextEntryWrapper: {
    position: 'relative',
    padding: 20,
    backgroundColor: '#ffffff',
  },
  threadLockedWrapper: {
    textAlign: 'center',
    padding: 20,
    backgroundColor: '#e3f2fd',
  },
  threadsDialogContent: {
    minWidth: 240,
    maxWidth: 420,
  },
  buttonWrapper: {
    padding: '4px 0 4px 10px',
  },
  button: {
    color: '#fff',
    backgroundColor: '#6bb570',
    '&:hover': {
      backgroundColor: '#1f7525',
    },
  },
});

const mapStateToProps = state => {
  return {
    messagesSelectedThread: state.messagesSelectedThread,
    selectedPupil: state.selectedPupil,
    messagesMultipleMessage: state.messagesMultipleMessage,
    messagesMultipleMessageSelectedIds: state.messagesMultipleMessageSelectedIds,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
    setDataBatch: (data) => dispatch(setDataBatch(data)),
  };
}

// TODO: Split into multiple components
class MessageThreadMessages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isLoading: false,
      isLoaded: false,
      isLoadingMessagesHistory: false,
      isMessagesHistoryLeft: true,
      isMessageSubmitting: false,
      text: '',
      isDeleteDialogOpen: false,
      selectedEntry: null,
      selectedFile: null,
    };

    this.fileInput = React.createRef();
    this.messagesContainer = React.createRef();
    this.messagesContent = React.createRef();
    this.textInput = React.createRef();
    this.axiosCancel = null;

    this.reloadData = this.reloadData.bind(this);
    this.onNewMessage = this.onNewMessage.bind(this);
    this.loadMessages = this.loadMessages.bind(this);
    this.onMessagesContainerScroll = this.onMessagesContainerScroll.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onLockUnlockClick = this.onLockUnlockClick.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onEntryDeleteClick = this.onEntryDeleteClick.bind(this);
    this.onEntryDeleteConfirmClick = this.onEntryDeleteConfirmClick.bind(this);
    this.onFileUploadClick = this.onFileUploadClick.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() {
    this.reloadData();

    this.messagesContainer.current.addEventListener('scroll', this.onMessagesContainerScroll);
    window.addEventListener('messaging:new-message', this.onNewMessage);
  }

  componentWillUnmount() {
    this.messagesContainer.current.removeEventListener('scroll', this.onMessagesContainerScroll);
    window.removeEventListener('messaging:new-message', this.onNewMessage);

    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const threadChanged = (
      (
        prevProps.messagesSelectedThread === null &&
        this.props.messagesSelectedThread !== null
      ) ||
      (
        prevProps.messagesSelectedThread !== null &&
        this.props.messagesSelectedThread === null
      ) ||
      (
        prevProps.messagesSelectedThread &&
        this.props.messagesSelectedThread &&
        prevProps.messagesSelectedThread.thread === null &&
        this.props.messagesSelectedThread.thread !== null
      ) ||
      (
        prevProps.messagesSelectedThread &&
        this.props.messagesSelectedThread &&
        prevProps.messagesSelectedThread.thread !== null &&
        this.props.messagesSelectedThread.thread === null
      ) ||
      (
        prevProps.messagesSelectedThread &&
        this.props.messagesSelectedThread &&
        prevProps.messagesSelectedThread.thread &&
        this.props.messagesSelectedThread.thread &&
        prevProps.messagesSelectedThread.thread.id !== this.props.messagesSelectedThread.thread.id
      )
    );

    if (threadChanged) {
      if (this.axiosCancel) {
        this.axiosCancel('thread_change');
      }

      // That's a pseudo-thread for the "Message multiple" functionality
      const isPseudoThread = (
        this.props.messagesSelectedThread &&
        this.props.messagesSelectedThread.id === -1
      );
      const wasPseudoThread = (
        prevProps.messagesSelectedThread &&
        prevProps.messagesSelectedThread.id === -1
      );
      if (isPseudoThread || wasPseudoThread) {
        this.setState({
          data: {},
          isLoaded: !wasPseudoThread,
          isLoading: false,
          isLoadingMessagesHistory: false,
          isMessagesHistoryLeft: false,
          isMessageSubmitting: false,
        });
      } else {
        this.reloadData();
      }
    }

    if (this.props.messagesMultipleMessage !== prevProps.messagesMultipleMessage) {
      this.setState({
        text: '',
        selectedFile: null,
      });
    }
  }

  reloadData() {
    const {
      enqueueSnackbar,
      selectedPupil,
      messagesSelectedThread,
    } = this.props;

    if (
      !selectedPupil &&
      !(
        appType === 'teacher' ||
        appType === 'teacher_admin'
      )
    ) {
      return;
    }

    if (!messagesSelectedThread) {
      return;
    }

    // If it's a pseudo-thread
    if (
      messagesSelectedThread &&
      messagesSelectedThread.thread &&
      messagesSelectedThread.thread.id === -1
    ) {
      this.setState({
        isLoading: false,
        isLoaded: true,
        isLoadingMessagesHistory: false,
        isMessagesHistoryLeft: false,
        isMessageSubmitting: false,
      });

      return;
    }

    const apiUrl = `${window.apiMessagingUrl}/getthread`;
    let apiParams = {};

    if (appType === 'teacher_admin') {
      apiParams = {
        thread_id: messagesSelectedThread.thread.id,
      };
    } else if (appType === 'teacher') {
      apiParams = (messagesSelectedThread.pupil_id // the pupil_id is only there if a parent thread is selected!
        ? {
          pupil_id: messagesSelectedThread.pupil_id,
          parent_id: messagesSelectedThread.id,
        }
        : {
          pupil_id: messagesSelectedThread.id,
        }
      );
    } else {
      apiParams = {
        pupil_id: selectedPupil.id,
        teacher_id: messagesSelectedThread.id,
      };
    }

    this.setState({
      data: {},
      isLoading: true,
      isLoadingMessagesHistory: false,
      isMessagesHistoryLeft: true,
      isMessageSubmitting: false,
    });

    axios
      .post(
        apiUrl,
        qs.stringify(apiParams),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });

          this.setState({
            isLoading: false,
            isLoaded: true,
          });
        } else {
          let newMessagesSelectedThread = messagesSelectedThread;

          if (newMessagesSelectedThread.thread === null) {
            newMessagesSelectedThread.thread = {
              id : response.data.data.id,
              last_message: null,
              locked: 'no',
              new_messages: 0,
            };
          } else {
            // At the moment we only want to update the locked status, when reloading the data
            newMessagesSelectedThread.thread.locked = response.data.data.locked;
            newMessagesSelectedThread.thread.locked_reason = response.data.data.locked_reason;
          }

          this.props.setData(newMessagesSelectedThread, 'messagesSelectedThread');

          this.setState({
            data: response.data.data,
            isLoading: false,
            isLoaded: true,
          }, () => {
            this.loadMessages('initial');
          });

          let detail = JSON.parse(JSON.stringify(newMessagesSelectedThread));
          detail.pupil_id = selectedPupil
            ? selectedPupil.id
            : (messagesSelectedThread.pupil_id
              ? messagesSelectedThread.pupil_id
              : messagesSelectedThread.id
            );

          window.dispatchEvent(new CustomEvent(
            'messaging:get-thread',
            {
              bubbles: true,
              detail,
            }
          ));
        }
      })
      .catch((thrown) => {
        if (thrown.message === 'thread_change') {
          this.setState({
            isLoading: false,
          });
        }
      });
  }

  onNewMessage(event) {
    const {
      messagesSelectedThread,
    } = this.props;

    if (
      event?.detail?.thread_id &&
      event?.detail?.message &&
      event?.detail?.message.id &&
      messagesSelectedThread?.thread &&
      event.detail.thread_id === messagesSelectedThread.thread.id
    ) {
      // Is that our currently open thread? If so, add it to messages!
      let newData = this.state.data;
      newData.messages = newData.messages?.concat([event.detail.message]) ?? [];

      this.setState({
        data: newData,
      });

      if (this.messagesContainer.current) {
        setTimeout(() => {
          // Jump to the bottom
          this.messagesContainer.current.scrollTop = this.messagesContainer.current.scrollHeight;
        });
      }
    }
  }

  loadMessages(type = 'initial') {
    const {
      enqueueSnackbar,
      selectedPupil,
      messagesSelectedThread,
    } = this.props;
    const {
      data,
      isLoadingMessagesHistory,
      isMessagesHistoryLeft,
    } = this.state;

    if (Object.keys(data).length === 0) {
      return;
    }

    const isInitialOrHistory = (
      type === 'initial' ||
      type === 'history'
    );

    if (
      isLoadingMessagesHistory ||
      (
        type === 'history' &&
        !isMessagesHistoryLeft
      )
    ) {
      return;
    }

    let message_id = null;

    if (data.messages.length > 0) {
      const index = type === 'new'
        ? data.messages.length - 1
        : 0;
      message_id = data.messages[index].id;
    } else if (
      type === 'new' &&
      data.messages.length === 0
    ) {
      message_id = 0;
    }

    if (message_id === null) {
      return;
    }

    this.setState({
      isLoadingMessagesHistory: type !== 'new',
    });

    const apiUrl = `${window.apiMessagingUrl}/getmessagesforthread`;
    let apiParams = {
      thread_id: messagesSelectedThread?.thread
        ? messagesSelectedThread.thread.id
        : 0,
      message_id: message_id,
      direction: !isInitialOrHistory
        ? 'forward'
        : 'back',
    };

    if (selectedPupil) {
      apiParams.pupil_id = selectedPupil.id;
    }

    axios
      .post(
        apiUrl,
        qs.stringify(apiParams),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          const meta = response.data.meta;
          const newMessages = response.data.data;
          let newData = this.state.data;

          if (type === 'new') {
            newData.messages = newData.messages.concat(newMessages);
          } else {
            newData.messages = newMessages.concat(newData.messages);
          }

          if (type === 'history' && this.messagesContent.current) {
            // Stay on the same scroll height when prepending new entries
            const messagesContentHeight = this.messagesContent.current.clientHeight;
            setTimeout(() => {
              const newMessagesContentHeight = this.messagesContent.current.clientHeight;
              this.messagesContainer.current.scrollTop = newMessagesContentHeight - messagesContentHeight;
            });
          }

          this.setState({
            data: newData,
          });

          if (type !== 'history' && this.messagesContent.current) {
            // Jump to the bottom
            this.messagesContainer.current.scrollTop = this.messagesContainer.current.scrollHeight;
          }

          if (isInitialOrHistory) {
            this.setState({
              isMessagesHistoryLeft: newMessages.length === meta.limit,
            });
          }
        }

        this.setState({
          isLoadingMessagesHistory: false,
        });
      })
      .catch((thrown) => {
        if (thrown.message === 'thread_change') {
          this.setState({
            isLoadingMessagesHistory: false,
          });
        }
      });
  }

  onMessagesContainerScroll(event) {
    if (event.target.scrollTop === 0) {
      this.loadMessages('history');
    }
  }

  onSubmitClick() {
    const {
      enqueueSnackbar,
      t,
      selectedPupil,
      messagesSelectedThread,
      messagesMultipleMessage,
      messagesMultipleMessageSelectedIds,
    } = this.props;
    const {
      selectedFile,
    } = this.state;

    this.setState({
      isMessageSubmitting: true,
    });

    let apiUrl = `${window.apiMessagingUrl}/replymessage`;
    let apiParams = {
      thread_id: messagesSelectedThread.thread.id,
      text: this.state.text,
    };

    if (selectedPupil) {
      apiParams.pupil_id = selectedPupil.id;
    }

    if (messagesMultipleMessage) {
      apiUrl = `${window.apiMessagingUrl}/messagemultiple`;
      apiParams = {
        text: this.state.text,
      };

      if (typeof Object.values(messagesMultipleMessageSelectedIds)[0] === 'string') {
        apiParams.type = 'pupil';
        apiParams.pupil_ids = Object.keys(messagesMultipleMessageSelectedIds);
      } else {
        apiParams.type = 'parent';
        apiParams.parent_pupil_ids = [];
        for (const key in messagesMultipleMessageSelectedIds) {
            for (const childKey in messagesMultipleMessageSelectedIds[key]) {
              apiParams.parent_pupil_ids.push([childKey, key]);
            }
          }
      }
    }

    let data = new FormData();

    for (const key in apiParams) {
      if (Array.isArray(apiParams[key])) {
        for (const index in apiParams[key]) {
          if (Array.isArray(apiParams[key][index])) {
            for (const subIndex in apiParams[key][index]) {
              data.append(
                key + '[' + index + '][' + subIndex + ']',
                apiParams[key][index][subIndex]
              );
            }
          } else {
            data.append(key + '[]', apiParams[key][index]);
          }
        }
      } else {
        data.append(key, apiParams[key]);
      }
    }

    if (selectedFile) {
      data.append('file[]', selectedFile);
    }

    axios
      .post(
        apiUrl,
        data,
        {
          cancelToken: new axios.CancelToken((c) => {
            this.axiosCancel = c;
          }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 3000,
          });

          this.setState({
            isMessageSubmitting: false,
          });
        } else {
          this.setState({
            text: '',
            isMessageSubmitting: false,
            selectedFile: null,
          });

          if (this.fileInput.current) {
            this.fileInput.current.value = null;
          }

          if (messagesMultipleMessage) {
            this.props.setDataBatch({
              messagesSelectedThread: null,
              messagesMultipleMessage: false,
            });

            enqueueSnackbar(t('You have successfully sent the message to the recipients'), {
              variant: 'success',
              autoHideDuration: 3000,
            });

            window.dispatchEvent(new CustomEvent(
              'messaging:new-batch-message',
              {
                bubbles: true,
                detail: {},
              }
            ));

            return;
          }

          window.dispatchEvent(new CustomEvent(
            'messaging:new-message',
            {
              bubbles: true,
              detail: {
                _source: 'myself',
                thread_id: messagesSelectedThread.thread.id,
                new_messages: 0, // Reset the counter, as we now obviously read the new messages
                last_message: moment().format(),
                message: response.data.data,
              },
            }
          ));
        }

        if (this.textInput.current) {
          this.textInput.current.focus();
        }
      })
      .catch((thrown) => {
        if (axios.isCancel(thrown)) {
          if (thrown.message === 'thread_change') {
            this.setState({
              isMessageSubmitting: false,
            });
          }
        } else if (!thrown.response) {
          this.setState({
            isMessageSubmitting: false,
          });

          enqueueSnackbar(t('Network error detected. Please make sure you are connected to the internet.'), {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else if (
          thrown.response &&
          thrown.response.data &&
          thrown.response.data.message
        ) {
          this.setState({
            isMessageSubmitting: false,
          });

          enqueueSnackbar(thrown.response.data.message, {
            variant: 'error',
            autoHideDuration: 3000,
          });
        }
      });
  }

  onBackClick() {
    this.props.setData(null, 'messagesSelectedThread');
  }

  onLockUnlockClick(newLockedStatus = 'yes') {
    const {
      enqueueSnackbar,
      t,
      messagesSelectedThread,
    } = this.props;

    const apiUrl = `${window.apiMessagingUrl}/setthreadstatus`;
    const apiParams = {
      thread_id: messagesSelectedThread.thread.id,
      locked: newLockedStatus,
    };

    axios
      .post(
        apiUrl,
        qs.stringify(apiParams),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          const text = newLockedStatus === 'no'
            ? t('You have successfully unlocked the thread')
            : t('You have successfully locked the thread');
          enqueueSnackbar(text, {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.reloadData();
        }
      })
      .catch((thrown) => {});
  }

  onInputKeyDown(event) {
    const {
      text,
    } = this.state;

    if (
      !!text &&
      !isMobileApp &&
      event.keyCode === 13 &&
      !event.shiftKey
    ) {
      this.onSubmitClick();
    }
  }

  onInputFocus(event) {
    const {
      messagesSelectedThread,
    } = this.props;

    // Reset the that threads counter in the threads list
    window.dispatchEvent(new CustomEvent(
      'messaging:get-thread',
      {
        bubbles: true,
        detail: messagesSelectedThread,
      }
    ));
  }

  onEntryDeleteClick(entry) {
    this.setState({
      selectedEntry: entry,
      isDeleteDialogOpen: true,
    });
  }

  onEntryDeleteConfirmClick() {
    const {
      t,
      enqueueSnackbar,
    } = this.props;
    const {
      selectedEntry,
    } = this.state;

    const selectedEntryId = selectedEntry.id;

    axios
      .post(
        `${window.apiMessagingUrl}/deletemessage`,
        qs.stringify({
          message_id: selectedEntryId,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });

          this.setState({
            isDeleteDialogOpen: false,
          });
        } else {
          enqueueSnackbar(t('You have successfully archived the message.'), {
            variant: 'success',
            autoHideDuration: 2000,
          });

          this.setState({
            selectedEntry: null,
            isDeleteDialogOpen: false,
          });

          // Set the selected message to deleted
          let newData = this.state.data;
          for (let i = 0; i < newData.messages.length; i++) {
            if (newData.messages[i].id === selectedEntryId) {
              newData.messages[i].deleted = 'yes';
              break;
            }
          }

          this.setState({
            data: newData,
          });
        }
      })
      .catch((thrown) => {});
  }

  onFileUploadClick() {
    this.fileInput.current.click();
  }

  onFileChange(e) {
    const file = e.target.files[0];

    if (file) {
      this.setState({
        selectedFile: file,
        text: file.name,
      });
    } else {
      this.setState({
        selectedFile: null,
        text: '',
      });
    }
  }

  render() {
    const {
      classes,
      t,
      selectedPupil,
      hideMessagesTextEntry,
      messagesSelectedThread,
      messagesMultipleMessageSelectedIds,
    } = this.props;
    const {
      isLoaded,
      isLoading,
      isLoadingMessagesHistory,
      data,
      text,
      isMessageSubmitting,
      isDeleteDialogOpen,
      selectedFile,
    } = this.state;

    const isTeacherAdminApp = appType === 'teacher_admin';
    const isTeacherOrTeacherAdminApp = appType === 'teacher' || isTeacherAdminApp;
    const analyticsUserType = messagesSelectedThread?.pupil_name ? 'messaging.parent-send' : 'messaging.pupil-send';
    let threadLockedReason = messagesSelectedThread?.thread?.locked_reason;
    let isThreadLocked = messagesSelectedThread?.thread?.locked !== 'no';
    let isThreadLockedAdmin = messagesSelectedThread?.thread?.locked === 'admin_locked';
    let showMessagesTextEntry = isTeacherAdminApp
      ? false
      : (
        !isThreadLocked &&
        !hideMessagesTextEntry
      );
    // TODO: move that whole logic below to the backend?
    let canLock = !isThreadLocked;
    let canAdminLock = !isThreadLocked && isTeacherAdminApp;
    let canUnlock = !isTeacherAdminApp && isThreadLockedAdmin
      ? false
      : isThreadLocked;
    const canUploadFiles = typeof enableMessagingAttachments !== 'undefined'
      ? enableMessagingAttachments
      : (selectedPupil
        ? selectedPupil.can_upload_attachments
        : false
      );

    const threadLastActive = messagesSelectedThread?.thread?.last_active
      ? moment(messagesSelectedThread?.thread?.last_active)
      : null;
    const isPseudoThread = messagesSelectedThread?.thread?.id === -1;
    if (isPseudoThread) {
      threadLockedReason = null;
      isThreadLocked = false;
      isThreadLockedAdmin = false;
      showMessagesTextEntry = true;
      canLock = false;
      canAdminLock = false;
      canUnlock = false;
    }

    let readEntryIndex = -1;
    let entries = [];
    if (
      data &&
      data.messages &&
      !isPseudoThread
    ) {
      let lastDate = null;
      for (let i = 0; i < data.messages.length; i++) {
        const message = data.messages[i];
        if (
          !message ||
          !message.timestamp
        ) {
          continue;
        }

        const timestamp = moment(message.timestamp);
        const date = timestamp.format('YYYY-MM-DD');

        if (date !== lastDate) {
          entries.push({
            key: date,
            type: 'date',
            data: date,
            has_read: false,
          });
        }

        let ownership = message.type === 'teacher'
          ? 'other'
          : 'my';
        if (isTeacherOrTeacherAdminApp) {
          ownership = message.type === 'teacher'
            ? 'my'
            : 'other';
        }

        const entryHasRead = (
          threadLastActive &&
          ownership === 'my' &&
          timestamp <= threadLastActive
        );

        entries.push({
          key: message.id,
          type: 'message',
          ownership: ownership,
          data: message,
          has_read: false,
        });

        lastDate = date;

        if (threadLastActive && entryHasRead) {
          readEntryIndex = entries.length -1;
        }
      }
    }

    if (readEntryIndex > -1) {
      entries[readEntryIndex].has_read = true;
    }

    let otherName = '';
    let topBannerContent = '';

    if (messagesSelectedThread) {
      otherName = messagesSelectedThread.name;
      const isParent = !!messagesSelectedThread.pupil_name;

      let pseudoThreadNames = [];
      if (isPseudoThread) {
        if (typeof Object.values(messagesMultipleMessageSelectedIds)[0] === 'string') {
          for (const key in messagesMultipleMessageSelectedIds) {
            pseudoThreadNames.push(messagesMultipleMessageSelectedIds[key]);
          }
        } else {
          for (const key in messagesMultipleMessageSelectedIds) {
            for (const childKey in messagesMultipleMessageSelectedIds[key]) {
              pseudoThreadNames.push(messagesMultipleMessageSelectedIds[key][childKey]);
            }
          }
        }
      }

      const showMoreLimit = isMobileApp ? 3 : 5;
      const showMoreButton = pseudoThreadNames.length > showMoreLimit;
      const finalThreads = pseudoThreadNames.slice(0, showMoreLimit);

      const topBannerText = isPseudoThread
        ? (
          <React.Fragment>
            <span>{t('Message being sent to')}: </span>
            {finalThreads.map((name) => {
              return (
                <Chip
                  key={name}
                  label={name}
                  className={classes.topBannerChip}
                />
              );
            })}
            {showMoreButton && (
              <>
                <Chip
                  label={t(
                    'show {more} more'
                      .replace('{more}', pseudoThreadNames.length - showMoreLimit)
                  )}
                  className={`${classes.topBannerChip} ${classes.topBannerChipShowMore}`}
                  onClick={() => {
                    const content = (
                      <div className={classes.threadsDialogContent}>
                        <h3>{t('Recipients')}</h3>
                        <ul>
                          {pseudoThreadNames.map((name) => {
                            return (
                              <li key={name}>
                                {name}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    );

                    confirm(content, {
                      hideConfirmButton: true,
                    });
                  }}
                />
              </>
            )}
            {finalThreads.length === 0 && (
              <span>{t('-- nobody --')}</span>
            )}
          </React.Fragment>
        )
        : (
          <React.Fragment>
            <span>{isTeacherAdminApp
              ? t('Chat between')
              : (isParent
                ? t('You are chatting with parent')
                : t('You are chatting with')
              )} </span>
            <b>{otherName}</b>
            {isParent && (
              <span> ({t('pupil')}: <b>{messagesSelectedThread.pupil_name}</b>)</span>
            )}
            {messagesSelectedThread.teacher_name && (
              <span> {t('and')} <b>{messagesSelectedThread.teacher_name}</b></span>
            )}
          </React.Fragment>
        );

      topBannerContent = (
        <React.Fragment>
          <Grid container justify="space-between">
            <Grid item>
              <div className={classes.topBannerText}>
                {topBannerText}
              </div>
            </Grid>
            {isTeacherOrTeacherAdminApp && (
              <Grid
                data-tracking-event="click"
                data-name="messaging.lock-messaging"
                data-product-area="messaging"
                data-module="two-way-communications"
                item
              >
                {canUnlock && (
                  <Tooltip title={t('Unlock')} placement="left">
                    <IconButton
                      size="medium"
                      onClick={this.onLockUnlockClick.bind(this, 'no')}
                      className={`unlock-button ${classes.lockUnlockIconButton}`}
                    >
                      <LockIcon className={classes.lockUnlockIcon} />
                    </IconButton>
                  </Tooltip>
                )}
                {canLock && (
                  <Tooltip title={t('Lock')} placement="left">
                    <IconButton
                      size="medium"
                      onClick={this.onLockUnlockClick.bind(this, 'yes')}
                      className={`lock-button ${classes.menuIconButton}`}
                    >
                      <LockOpenIcon className={classes.lockUnlockIcon} />
                    </IconButton>
                  </Tooltip>
                )}
                {canAdminLock && (
                  <Tooltip title={t('Admin lock')} placement="left">
                    <IconButton
                      size="medium"
                      onClick={this.onLockUnlockClick.bind(this, 'admin_locked')}
                      className={`lock-unlock-admin-menu-button ${classes.lockUnlockIconButton}`}
                    >
                      <EnhancedEncryptionIcon className={classes.lockUnlockIcon} />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            )}
          </Grid>
        </React.Fragment>
      );
    }

    return (
      <div className={`message-thread-messages ${classes.root}`}>
        {!messagesSelectedThread && (
          <div className={classes.noneSelected}>
            {t('Please select a thread on the left side to view the messages')}
          </div>
        )}
        {isLoading && !isLoaded && (
          <div className={classes.centerPadding}>
            <CircularProgress />
          </div>
        )}
        <div className={classes.messagesContainerWrapper}>
          {isLoaded && messagesSelectedThread && (
            <div className={classes.topBanner}>
              <Grid container justify="space-between">
                {isMobileApp && (
                  <Grid item style={{ flex: 0 }}>
                    <IconButton
                      size="medium"
                      onClick={this.onBackClick}
                      className="back-button"
                    >
                      <ArrowBackIcon className={classes.backButtonIcon} />
                    </IconButton>
                  </Grid>
                )}
                <Grid item style={{ flex: 1 }}>
                  {topBannerContent}
                </Grid>
              </Grid>
            </div>
          )}
          <div className={classes.messagesWrapper}>
            <div
              className={classes.messagesInner}
              ref={this.messagesContainer}
            >
              {isLoaded && messagesSelectedThread && entries.length === 0 && (
                <div className={classes.centerPadding}>
                  {t('No messages yet')}
                </div>
              )}
              <div className={classes.messagesInnerDownPusher}></div>
              <div
                className={classes.messagesInnerContainer}
                ref={this.messagesContent}
              >
                {isLoadingMessagesHistory && (
                  <div className={classes.centerPaddingSmall}>
                    <CircularProgress />
                  </div>
                )}
                {isLoaded && messagesSelectedThread && entries.map((entry) => {
                  return (
                    <MessageThreadMessagesEntry
                      key={entry.key}
                      data={entry}
                      otherName={otherName}
                      onDeleteClick={this.onEntryDeleteClick}
                    />
                  )
                })}
              </div>
              {threadLockedReason && (
                <div className={classes.threadLockedWrapper}>
                  {threadLockedReason}
                </div>
              )}
            </div>
          </div>
          {showMessagesTextEntry && (
            <div className={classes.messagesTextEntryWrapper}>
              <Grid container>
                <Grid item style={{ flex: '1 1 auto' }}>
                  <TextField
                    fullWidth
                    multiline
                    rowsMax="3"
                    variant="outlined"
                    placeholder={t('Type a message ...')}
                    disabled={isMessageSubmitting || !!selectedFile}
                    value={text}
                    onChange={(event) => {
                      this.setState({
                        text: event.target.value,
                      })
                    }}
                    onKeyDown={this.onInputKeyDown}
                    onFocus={this.onInputFocus}
                    inputRef={this.textInput}
                  />
                </Grid>
                {canUploadFiles && (
                  <Grid item>
                    <div className={classes.buttonWrapper}>
                      <IconButton
                        size="medium"
                        onClick={this.onFileUploadClick}
                        className="file-upload-button"
                      >
                        {selectedFile && (
                          <Badge color="secondary" variant="dot">
                            <AttachFileIcon />
                          </Badge>
                        )}
                        {!selectedFile && (
                          <AttachFileIcon />
                        )}
                      </IconButton>
                      <input
                        ref={this.fileInput}
                        type="file"
                        style={{display: 'none'}}
                        onChange={this.onFileChange}
                      />
                    </div>
                  </Grid>
                )}
                <Grid item>
                  <div
                    className={classes.buttonWrapper}
                  >
                    <IconButton
                      size="medium"
                      data-tracking-event="click"
                      data-name={analyticsUserType}
                      data-product-area="messaging"
                      data-module="two-way-communications"
                      onClick={this.onSubmitClick}
                      disabled={isMessageSubmitting || text === ''}
                      className={`submit-button ${classes.button}`}
                    >
                      {!isMessageSubmitting && (
                        <SendIcon />
                      )}
                      {isMessageSubmitting && (
                        <CircularProgress size={20} />
                      )}
                    </IconButton>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
        <ConfirmDialog
          useSuspense={false}
          title={t('Confirmation')}
          isOpen={isDeleteDialogOpen}
          onClose={() => this.setState({
            isDeleteDialogOpen: false,
          })}
          onConfirm={this.onEntryDeleteConfirmClick}
        >
          {t('Are you sure you want to archive this message?')}
        </ConfirmDialog>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(MessageThreadMessages)))
);
